import { APP_INITIALIZER, ErrorHandler, type Provider } from '@angular/core';
import Honeybadger from '@honeybadger-io/js';
import { HoneybadgerErrorHandler } from './honeybadger-error-handler';
import { Environment, type EnvironmentType } from '@td/core';
import { revision } from './revision/revision';

function initialize(environment: EnvironmentType) {
  const developmentEnvironments = ['local', 'develop', 'test'];

  Honeybadger.beforeNotify((error) => {
    if (developmentEnvironments.includes(environment.name)) {
      console.error(error?.stack);
    }
    if (error?.message?.includes('error loading dynamically imported module')) {
      return false;
    }
    if (error?.message?.includes('Importing a module script failed.')) {
      return false;
    }
    return;
  });

  return (): Honeybadger => {
    return Honeybadger.configure({
      apiKey: environment.honeybadgerApiKey,
      environment: environment.name,
      developmentEnvironments,
      revision,
      breadcrumbsEnabled: {
        dom: true,
        network: true,
        navigation: true,
        console: !developmentEnvironments.includes(environment.name),
      },
    });
  };
}

export function provideHoneybadger(): Array<Provider> {
  return [
    {
      provide: APP_INITIALIZER,
      useFactory: initialize,
      multi: true,
      deps: [Environment],
    },
    { provide: ErrorHandler, useClass: HoneybadgerErrorHandler },
  ];
}
